/*
 * @Author: lijianhui
 * @Date: 2020-08-24 14:34:46
 * @Last Modified by: lijianhui
 * @Last Modified time: 2021-08-03 09:07:24
 * type: 0注册。1找回密码
 * platform: personal个人，financial：企业，agency：财税机构
 */

import './common/base.js'
import '@/scss/common/base.scss'
import '@/scss/register.scss'
import {
  getUrlQuery,
  searchConpany,
  preRequestDeal,
  dealSms,
  verifyMobilePhone,
  dealProtectionToken,
  setAuthInfo,
  getAuthInfo,
} from './common/tool'
import {
  getClientConfig,
  register,
  registerEnterprise,
  resetPassword,
  createEnterpriseFromJson,
  createEnterpriseCustomer,
  openUploadFile,
  openPargeLicenseValidation,
} from './common/api'
import { FINANICALWEB, PERSONALWEB, REIMBURSEMENT, BILLCENTERWEB } from './common/constant'
$(function () {
  let cascadeLock = false
  let time = 60 // 获取验证码倒计时
  let codeTimer = ''
  const type = getUrlQuery('type') || '0' // 0注册。1找回密码
  const platform = getUrlQuery('platform') || 'personal' // personal个人，financial：企业，agency：财税机构
  /* 邀请开通和代开通的字段 */
  const inviteName = $.$urlQuery.get('inviteName')
  const name = $.$urlQuery.get('name')
  const id = $.$urlQuery.get('id')
  let licenseData = {} // 营业执照数据
  /* currId：目前用于注册财税机构后待审核的企业id，刷新后如果审核通过进入对应的页面 */
  init()

  function init() {
    platform === 'personal' ? $('#personal').show() : $('#public-reg').show()
    $('#personal .form-head').text(type == 1 ? '重置密码' : '注册个人账号')
    $('#personal .submit').text(type == 1 ? '重置密码' : '注册')
    if (platform !== 'personal') {
      initClientConfig()
      const register = $('#public-reg')
      $('.register-footer').removeClass('fixed-bottom')

      if (platform === 'financial') {
        register.find('.form-head').text('注册企业账号')
        register.find('.company-info h4').text('企业信息')
        register.find('#companyName').attr('placeholder', '填写企业、政府或组织名称')
        /* 还有种邀请开通的还是代开通的情况，会在url添加inviteName=ivva&name=123&id=123456参数 */
        if (inviteName) {
          // register.find(".form-head").text(`${inviteName}邀请您开通${$.$WEBNAME || '票易得'}企业账号`)
        }
        if (name) {
          register.find('#companyName').val(name)
        }
        /* 已登录账号则不需要显示填写管理员信息表单 */
      } else if (platform === 'agency') {
        register.find('.form-head').text('注册财税机构运营账号')
        register.find('.company-info h4').text('机构信息')
        register.find('#companyName').attr('placeholder', '填写机构名称')
        register.find('.industry').hide()
        register.find('.companyName-label').text('财税机构名称')
        /* 注册成功后 */
        const registerSuccess = getUrlQuery('success')
        if (registerSuccess == '1') {
          $('#public-reg .unRegister').hide()
          $('#public-reg .successTemplate').show()
        } else {
          $('#public-reg .unRegister').show()
          $('#public-reg .successTemplate').hide()
        }
      }
    } else {
      $('#top').hide()
    }
    preRequestDeal()
    // $('.agreements a').text(`《${$.$WEBNAME || '票易得'}企业服务协议》`)
  }
  async function initClientConfig() {
    const res = await getClientConfig({
      types: ['enterpriseStaffSize', 'enterpriseIndustryCode'],
    })
    if (res.ResCode === 1000) {
      for (const item of res.Data) {
        if (item.Key === 'enterpriseIndustryCode') {
          $('.cascade-selsect').html(initIndustry(item.Childs))
          $('#industry').focus(function () {
            $('.cascade').show()
          })
          $('#industry').blur(function () {
            if (!cascadeLock) {
              $('.cascade').hide()
            }
          })
        } else if (item.Key === 'enterpriseStaffSize') {
          initStaffSize(item.Childs)
        }
      }
    }
    /* 处理联级选择事件 */
    $('.cascade-selsect').on('mouseenter', '.cascade-menu li', function () {
      const childs = $(this).data('childs') || []
      cascadeLock = true
      if (childs.length) {
        let childHtml = initIndustry(childs)
        $(this).parent('.cascade-menu').nextAll().remove()
        $(this).parent('.cascade-menu').parent().append(childHtml)
      }
    })
    $('.cascade-selsect').on('mouseleave', function () {
      cascadeLock = false
    })
    $('.cascade-selsect').on('click', '.cascade-menu li', function () {
      if (!$(this).hasClass('more')) {
        const key = $(this).data('key')
        const value = $(this).text()
        $('#industry').val(value)
        $('#industry').attr('key', key)
        $('.cascade').hide()
      }
    })
  }
  const initIndustry = (list) => {
    let html = `<ul class="cascade-menu">`
    for (const item of list) {
      html += `<li class=${item.Childs && item.Childs.length ? 'more' : ''} data-key=${
        item.Key
      } data-childs=${item.Childs ? JSON.stringify(item.Childs) : []}>${item.Value}</li>`
    }
    html += `</ul>`
    return html
  }
  const initStaffSize = (list) => {
    let html = `<option value="">请选择人员规模</option>`
    for (const item of list) {
      html += `<option value=${item.Key}>${item.Value}</option>`
    }
    $('#staffSize').html(html)
  }
  const registerMain = $('.register-main')
  registerMain.on('click', '.sms-code-btn', async function () {
    const mobilePhone = $(this).parents('.form-body').find('.mobilePhone').val()
    const msgErr = verifyMobilePhone(mobilePhone)
    if (msgErr) {
      $.$msg(msgErr)
      return
    }
    const smsReqdata = {
      Account: mobilePhone,
      FlagType: handleFlagType(), // 1注册，2找回密码
    }
    $(this).attr('disabled', true)
    const smsRes = await dealSms(smsReqdata)
    if (smsRes.ResCode !== 1000) {
      $(this).attr('disabled', false)
      $.$msg(smsRes.Msg)
      return
    }
    let codeTime = time
    const self = $(this)
    self.text(`${codeTime}秒后重新获取`)
    codeTimer = setInterval(() => {
      if (codeTime <= 0) {
        clearInterval(codeTimer)
        self.text(`获取验证码`).attr('disabled', false)
        return
      }
      codeTime -= 1
      self.text(`${codeTime}秒后重新获取`)
    }, 1000)
  })
  registerMain.on('click', '.submit', function () {
    debugger
    console.log('submit', platform)
    let params = {}
    if (platform === 'personal') {
      params = {
        MobilePhone: $('#personal .mobilePhone').val(),
        Password: $('#personal .password').val(),
        ValidCode: $('#personal .CaptchaCode').val(),
        checkPassword: $('#personal .checkPassword').val(),
      }
      const verify = verifiBaseInfo(params, 'ValidCode')
      if (verify) {
        if (type == 1) {
          handleResetPassword(params)
        } else {
          register(params).then((res) => {
            if (res.ResCode === 1000) {
              setAuthInfo({ Token: res.Token })
              setTimeout(() => {
                window.location.replace(PERSONALWEB)
              })
            } else {
              $.$msg(res.Msg)
            }
          })
        }
      }
    } else {
      if (!$('#agreements').is(':checked')) {
        $.$msg('请先同意并遵守用户协议')
        return
      }
      let verify = '',
        createApi = registerEnterprise
      if ($._isLogin && !id) {
        // 已登录而且不是代开通和邀请开通的用另一个接口
        params = {
          Name: $('#public-reg .enterpriseName').val(),
          StaffSize: $('#public-reg .staffSize').val(),
          IsAgency: platform === 'agency',
          IndustryCode: $('#public-reg .industryCode').val(),
          Token: $._userInfo.Token,
          LicenseValidationId: licenseData.Id,
        }
        verify = verifiLoginOtherInfo(params)
        createApi = createEnterpriseFromJson
      } else {
        params = {
          EnterpriseName: $('#public-reg .enterpriseName').val(),
          IndustryCode: $('#public-reg .industryCode').val(),
          StaffSize: $('#public-reg .staffSize').val(),
          Administrator: $('#public-reg .administrator').val(),
          MobilePhone: $('#public-reg .mobilePhone').val(),
          CaptchaCode: $('#public-reg .captchaCode').val(),
          Password: $('#public-reg .password').val(),
          checkPassword: $('#public-reg .checkPassword').val(),
          IsAgency: platform === 'agency',
          LicenseValidationId: licenseData.Id,
        }
        verify = verifiOtherInfo(params) && verifiBaseInfo(params, 'CaptchaCode')
      }
      if (verify) {
        if (type == 1) {
          handleResetPassword(params)
        } else {
          console.log('params', params)
          createApi(params).then((res) => {
            if (res.ResCode === 1000) {
              if (platform === 'agency') {
                if (res.Token) {
                  setAuthInfo({
                    CurrentUserId: res.User && res.User.UserId,
                    CurrentUserName: res.User && res.User.UserName,
                    IsCreater: true,
                    IsAdmin: true,
                    Token: res.Token,
                  })
                }
                let newUrl = $.$urlQuery.set('success', 1, false)
                const currAgencyId = $._isLogin && !id ? res.Data.Id : res.Enterprise.Id
                $.$urlQuery.set('currId', currAgencyId, true, newUrl)
              } else {
                if ($._isLogin && !id) {
                  setAuthInfo({
                    EnterpriseId: res.Data.Id,
                  })
                } else {
                  setAuthInfo({
                    CurrentUserId: res.User && res.User.UserId,
                    CurrentUserName: res.User && res.User.UserName,
                    EnterpriseId: (res.Enterprise && res.Enterprise.Id) || '',
                    IsCreater: true,
                    IsAdmin: true,
                    Token: res.Token,
                  })
                }

                if (id) {
                  let postData = {
                    EnterpriseId: id,
                  }
                  //邀请开通
                  if (inviteName) {
                    Object.assign(postData, {
                      EnterpriseName: inviteName,
                      CustomerEnterpriseId: getAuthInfo().EnterpriseId,
                    })
                  } else {
                    //代理开通
                    Object.assign(postData, {
                      CustomerEnterpriseName: name,
                    })
                  }
                  createEnterpriseCustomer(postData).then((res) => {
                    if (res.ResCode === 1000) {
                      if (inviteName) {
                        window.location.replace(REIMBURSEMENT)
                      } else {
                        window.location.replace(BILLCENTERWEB)
                      }
                    } else {
                      $.$msg(res.Msg)
                    }
                  })
                } else {
                  const isPc = getUrlQuery('isPc')
                  let finanicaWeb = FINANICALWEB
                  if (isPc) {
                    finanicaWeb = finanicaWeb.replace(
                      /web/gi,
                      `web${Math.floor(Math.random() * 10)}`
                    )
                    finanicaWeb += `?isPc=${isPc}`
                  }
                  const cb = getUrlQuery('cb')
                  if (cb) {
                    window.location.replace(decodeURIComponent(cb))
                    return
                  }
                  setTimeout(() => {
                    window.location.replace(finanicaWeb)
                  }, 500)
                }
              }
            } else {
              $.$msg(res.Msg)
            }
          })
        }
      }
    }
  })

  const verifiBaseInfo = (form, ValidCode) => {
    if (verifyMobilePhone(form.MobilePhone)) {
      $.$msg(verifyMobilePhone(form.MobilePhone))
      return false
    }
    if (ValidCode && form.hasOwnProperty(ValidCode) && form[ValidCode].length < 6) {
      $.$msg('请输入正确的验证码')
      return false
    }
    /* if (!form.Password || form.Password.length < 6) {
      $.$msg('请输入正确的密码')
      return false
    }
    if (form.Password !== form.checkPassword) {
      $.$msg('两次密码不一致')
      return false
    } */
    return true
  }
  const verifiOtherInfo = (form) => {
    if (!form.EnterpriseName) {
      $.$msg($.$platform() === 'agency' ? '请输入财税机构' : '请输入企业名称')
      return false
    }
    /* if (platform === 'financial' && !form.IndustryCode) {
      $.$msg('请选择行业类型')
      return false
    }
    if (!form.StaffSize) {
      $.$msg('请选择人员规模')
      return false
    } */
    // if (!form.LicenseValidationId) {
    //   $.$msg('请上传营业执照')
    //   return false
    // }
    // if (licenseData.Name !== form.EnterpriseName) {
    //   $.$msg('营业执照名称与企业名称不一致，请重新上传')
    //   return false
    // }

    return true
  }
  const verifiLoginOtherInfo = (form) => {
    if (!form.Name) {
      $.$msg($.$platform() === 'agency' ? '请输入财税机构' : '请输入企业名称')
      return false
    }
    /* if (platform === 'financial' && !form.IndustryCode) {
      $.$msg('请选择行业类型')
      return false
    }
    if (!form.StaffSize) {
      $.$msg('请选择人员规模')
      return false
    } */
    // if (!form.LicenseValidationId) {
    //   $.$msg('请选择上传营业执照')
    //   return false
    // }
    // if (licenseData.Name !== form.Name) {
    //   $.$msg('营业执照名称与企业名称不一致，请重新上传')
    //   return false
    // }
    return true
  }
  registerMain.on('keyup', '#companyName', function () {
    searchConpany('#companyName', '.company-dropdown')
  })
  registerMain.on('blur', '#companyName', function () {
    setTimeout(() => {
      $('#companyName').dropdown('hide')
      valiyCompanyName()
    }, 300)
  })
  registerMain.on('click', '.company-dropdown li', function () {
    $('#companyName').val($(this).text()).data('code', $(this).data('code'))
  })

  const handleFlagType = () => {
    // 验证码FlagType字段，0 = AuthCodeLogin(验证码登录), 1 = Register(注册), 2 = PasswordRetrieval(找回密码), 3 = Account(手机或邮箱验证), 4 = EnterpriseRegister(单位账号注册), 5 = PhoneBind(手机号绑定), 6 = VerifyEnterpriseUser(单位用户验证), 7 = ChangePhone(更改手机号)
    /* type: 0注册。1找回密码
     * platform: personal个人，financial：企业，agency：财税机构 */
    // 根据type, platform来判断
    let flagType = ''
    if (type == 0 && platform === 'personal') {
      flagType = 1
    } else if (
      type == 0 &&
      (platform === 'financial' || platform === 'agency' || platform === 'enterprise')
    ) {
      flagType = 4
    } else if (type == 1) {
      flagType = 2
    }
    return flagType
  }
  const handleResetPassword = (params) => {
    resetPassword(params).then((res) => {
      if (res.ResCode === 1000) {
        $.$msg('密码重置成功！', 'alert-success')
        let url = ''
        if (url) {
        }
        setTimeout(() => {
          window.location.href = '/'
        }, 1000)
      } else {
        $.$msg(res.Msg)
      }
    })
  }

  $('.license-input').on('change', async function (e) {
    const file = e.target.files[0]
    const fileName = file.name
    const fileSize = file.size
    const fileType = fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase()
    if (!['jpg', 'png', 'jpeg', 'webp', 'bmp'].includes(fileType)) {
      $.$msg('请上传图片格式')
      return
    }
    if (fileSize > 2 * 1024 * 1024) {
      $.$msg('请上传图片不得大于2M')
      return
    }
    $('.vali-status').removeClass('success fail').addClass('uploading')
    const fileRes = await openUploadFile({
      File: file,
      BusinessType: 'ImportEnterpriseCustomer',
    })
    let errMsg = ''
    $('.vali-status').removeClass('uploading')
    if (fileRes.ResCode === 1000) {
      $('.license-img').attr('src', fileRes.Data.FilePath).show()
      const licenseRes = await openPargeLicenseValidation({
        FileUrl: fileRes.Data.FilePath,
      })
      if (licenseRes.ResCode === 1000) {
        licenseData = licenseRes.Data
        valiyCompanyName()
      } else {
        errMsg = licenseData.Msg
      }
    } else {
      errMsg = fileRes.Msg
    }
    if (errMsg) {
      $.$msg(errMsg)
    }
  })

  function valiyCompanyName() {
    const companyName = $('#companyName').val()
    console.log('companyName', companyName)
    if (licenseData && licenseData.Id && companyName) {
      // 有上传营业执照则认证
      if (companyName === licenseData.Name) {
        $('.vali-status').addClass('success').removeClass('fail')
      } else {
        $('.vali-status').addClass('fail').removeClass('success')
      }
    } else {
      $('.vali-status').removeClass('success fail uploading')
    }
  }
  $('.agreement-text').on('click', function () {
    // window.open('./static/爱发票企业服务协议.pdf')
  })
})
